import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { BossHomeFlatsCount } from '@utils/models/BossHome';
import { stringifyUrl } from 'query-string';
import { useQuery } from 'react-query';
import { StringParam, useQueryParams } from 'use-query-params';

import { queryKeys } from '../constants';

export function useFlatsCountBossV2() {
  const [query] = useQueryParams({
    houses: StringParam,
    buildings: StringParam
  });

  return useQuery<BossHomeFlatsCount>(
    [queryKeys.BOSS_FLATS_COUNT, query],
    async () => {
      const res = await Promise.all([
        $api.get(
          stringifyUrl({
            url: `/v2/mobile/flat/sold`,
            query
          })
        ),
        $api.get(
          stringifyUrl({
            url: `/v2/mobile/client/booking`,
            query
          })
        ),
        $api.get(
          stringifyUrl({
            url: `/v2/mobile/flat/blank`,
            query
          })
        ),
        $api.get(
          stringifyUrl({
            url: `/v2/mobile/flat/reserved`,
            query
          })
        )
      ]);

      return {
        empty: res[2].data.data,
        booked: res[1].data.data,
        sold: res[0].data.data,
        reserved: res[3].data.data
      };
    },
    {
      refetchOnWindowFocus: false,
      onError: baseErrorHandler,
      retry: false
    }
  );
}
